import { message as $message } from 'antd'
import moment from 'moment'

// 创建导出文件名称
export const createFileName = name => `${name || '聚水潭分销版'} ${moment().format('Y年M月D日')}`

export const exportExcel = async ({ fetch, name }) => {
    try {
        const response = await fetch()

        if (response) {
            if (response instanceof Blob) {
                const linkEle = document.createElement('a')

                const blobFile = new Blob([response], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
                })

                linkEle.href = URL.createObjectURL(blobFile)
                linkEle.download = `${createFileName(name)}.xlsx`
                linkEle.click()

                window.URL.revokeObjectURL(linkEle.href)

                return Promise.resolve()
            } else {
                const { success, message } = response

                if (!success) {
                    $message.error(message)
                }

                return Promise.reject(new Error(message))
            }
        }
    } catch (e) {
        console.error('catchError', e)
        $message.error('导出失败')

        return Promise.reject(e)
    }
}

export const getFileBlob = url => {
    return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
            if (xhr.status === 200) {
                resolve(xhr.response)
            }
        }
        xhr.send()
    })
}

export const exportExcelByUrl = async ({ url, name }) => {
    return await exportExcel({
        fetch: () => getFileBlob(url),
        name
    })
}
